<h1 mat-dialog-title>{{'website.header.modal.title' | translate}}</h1>
<div mat-dialog-content *ngIf="isTokenPresent">
  <h4>{{'website.header.modal.content' | translate}}: <b>{{token | uppercase}}</b></h4>
</div>
<mat-spinner *ngIf="!isTokenPresent"></mat-spinner>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>{{'website.header.modal.footer' | translate}}</button>
</div>